import type { Props as CurrenciesSelectProps } from '@/components/CurrenciesSelect';
import { CurrenciesSelect } from '@/components/CurrenciesSelect';
import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { CellProps } from './type';
type Props<TFieldValues extends FieldValues> =
  CurrenciesSelectProps<TFieldValues> & CellProps;

export const CurrencySelectCell = <TFieldValues extends FieldValues>({
  index,
  ...props
}: Props<TFieldValues>) => {
  const cacheKey = useMemo(() => ['row', 'currency', index], [index]);

  return <CurrenciesSelect per={500} cacheQueryKey={cacheKey} {...props} />;
};
CurrencySelectCell.displayName = 'CurrencySelectCell';
